import logo from 'assets/logo.svg';
import { Button } from 'components';
import { CPFFormat } from 'components/CPFFormat';
import { Snackbar } from 'components/Snackbar';
import { useFormik } from 'formik';
import { useQuery } from 'hooks/useQuery';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { forgotPasswordValidation } from 'schemas';
import { AuthService } from 'services';

import { Alert, Box, Container, Grid, Paper, Typography } from '@mui/material';

export const ForgotPassword: React.FC = () => {
  const [error, setError] = useState('');
  const history = useHistory();
  const query = useQuery();
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleSubmit = async (values: any) => {
    const role = query.get('role');
    try {
      if (role) {
        const response = await AuthService.forgotPassword(values.cpf, role);
        if (response.status === 200) {
          setSnackbarOpen(true);

          setTimeout(history.goBack, 3000);
        }
      }
    } catch (error: any) {
      setError('Não foi possível redefinir a senha');
    }
  };

  const formik = useFormik({
    initialValues: {
      cpf: '',
    },
    validationSchema: forgotPasswordValidation,
    onSubmit: handleSubmit,
  });
  return (
    <Grid container justifyContent="center" alignItems="center" height="100vh">
      <Container component="main" maxWidth="xs">
        <Paper variant="outlined" sx={{ p: 4 }}>
          <Grid container>
            <Grid item container xs={12} justifyContent="center">
              <Box component="img" alt="Vet4all logo" src={logo} />
            </Grid>
            <Grid item xs={12}>
              <Typography
                textAlign="center"
                component="h1"
                variant="h5"
                sx={{ fontWeight: 400, fontSize: 34, py: 2 }}
              >
                Recuperar Senha
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box component="form" onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CPFFormat
                      required
                      fullWidth
                      id="cpf"
                      name="cpf"
                      label="CPF"
                      autoComplete="off"
                      value={formik.values.cpf}
                      onChange={formik.handleChange}
                      error={formik.touched.cpf && Boolean(formik.errors.cpf)}
                      helperText={formik.touched.cpf && formik.errors.cpf}
                      placeholder="___.___.___-__"
                    />
                  </Grid>
                  {error && (
                    <Grid item xs={12} sx={{ mt: 2 }}>
                      <Alert severity="error">{error}</Alert>
                    </Grid>
                  )}
                </Grid>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item>
                    <Button
                      onClick={() => history.goBack()}
                      sx={{ mt: 3, mb: 2, color: '#FFFFFF' }}
                    >
                      Voltar
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      type="submit"
                      sx={{ mt: 3, mb: 2, color: '#FFFFFF' }}
                    >
                      Enviar
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>

      <Snackbar
        text="Você receberá um email com informações de como resetar a sua senha"
        snackbarOpen={snackbarOpen}
        setSnackbarOpen={setSnackbarOpen}
        severityType="warning"
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      />
    </Grid>
  );
};

